module.exports = __webpack_public_path__ + "img/step-2.2a5bed45.jpg";